import { render, staticRenderFns } from "./ChooseBeneficiary.vue?vue&type=template&id=db57be48&scoped=true"
import script from "./ChooseBeneficiary.vue?vue&type=script&lang=js"
export * from "./ChooseBeneficiary.vue?vue&type=script&lang=js"
import style0 from "./ChooseBeneficiary.vue?vue&type=style&index=0&id=db57be48&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db57be48",
  null
  
)

export default component.exports